@if (dataTable?.tableConfig?.tabs?.length > 1) {
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    @for (tab of dataTable.tableConfig.tabs; track tab) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ tab.tableView.title }}</span
          >&nbsp;
          <span>({{ tabsCount.get(tab.tableView.code) }})</span>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
}
